/**
 * Centralized API & Environment Configuration
 *
 * Architecture:
 *   Environment Config (.env / .env.development / .env.production)
 *       ↓
 *   Single API Base URL (REACT_APP_API_BASE_URL)
 *       ↓
 *   Centralized API Config (src/config/apiConfig.js)
 *       ↓
 *   Centralized API Client (apiClient in src/services/api.js)
 *       ↓
 *   All Application API Calls
 */

const rawApiUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

const cleanUrl = rawApiUrl
  .trim()
  .replace(/\/swagger(\/index\.html)?\/?$/i, '')
  .replace(/\/+$/, '');

// Centralized API Base URL for backend endpoints
export const API_BASE_URL = cleanUrl.endsWith('/api/v1') ? cleanUrl : `${cleanUrl}/api/v1`;

// Root host URL for static uploads and file previews
export const FILE_BASE_URL = API_BASE_URL.replace(/\/api\/v1\/?$/, '');

const apiConfig = {
  baseURL: API_BASE_URL,
  fileBaseURL: FILE_BASE_URL,
  timeout: 30000,
};

export default apiConfig;
